import React, { createContext, useContext, ReactNode } from 'react';

interface RegistrationContextType {
  orderToken: string | null;
  eventSlug: string | null;
  isRegistrationContext: boolean;
}

const RegistrationContext = createContext<RegistrationContextType | null>(null);

interface RegistrationProviderProps {
  children: ReactNode;
  orderToken?: string;
  eventSlug?: string;
}

export const RegistrationProvider: React.FC<RegistrationProviderProps> = ({ 
  children, 
  orderToken = null,
  eventSlug = null
}) => {
  return (
    <RegistrationContext.Provider value={{
      orderToken,
      eventSlug,
      isRegistrationContext: true
    }}>
      {children}
    </RegistrationContext.Provider>
  );
};

// Hook to use the registration context
export const useRegistrationContext = () => {
  const context = useContext(RegistrationContext);
  if (!context) {
    // Return a default context for components used outside registration
    return {
      orderToken: null,
      eventSlug: null,
      isRegistrationContext: false
    };
  }
  return context;
};